import React from 'react';
import {CNavGroup, CNavItem, CNavTitle} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import {
  cilAddressBook,
  cilAirplay,
  cilAlarm,
  cilAppsSettings,
  cilBank,
  cilCamera,
  cilChart,
  cilClipboard,
  cilCloudUpload,
  cilCode,
  cilCursor,
  cilDevices,
  cilDrop,
  cilEnvelopeOpen,
  cilLayers,
  cilLocationPin,
  cilMap,
  cilMobile,
  cilMoney,
  cilNotes,
  cilPeople,
  cilPhone,
  cilRouter,
  cilSatelite,
  cilSettings,
  cilShieldAlt,
  cilShower,
  cilSignalCellular0,
  cilSim,
  cilSmoke,
  cilSpeedometer,
  cilStar,
  cilTablet,
  cilUser,
  cilUserFollow,
  cilUserPlus,
  cilVector,
  cilWarning,
  cilXCircle,
} from '@coreui/icons'

export  const DASHBOARD_NAV = {
  component: CNavItem,
  name: 'Dashboard',
  to: '/dashboard',
  id: 'dashboard',
  icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  badge: {
    color: 'info',
    // text: 'NEW',
  },
}

export  const ACCOUNTANT_PROFILE_NAV = {
  component: CNavItem,
  name: 'Account Profile',
  to: '/admin/account-profile',
  id: 'account_profile',
  icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
  badge: {
    color: 'info',
    // text: 'NEW',
  },
}

export  const SECUREME_NAV = {
  component: CNavGroup,
  name: 'Secure Me',
  to: '/secure-me',
  id: 'secure_me',
  icon: <CIcon icon={cilShieldAlt} customClassName="nav-icon" />,
  visible: true,
  items: []
}

export  const SECUREME_NAV_CHILDREN = [
    {
      component: CNavItem,
      name: 'Secureme Subscribers',
      to: '/secureme/secureme-subscribers-list',
      id: 'secure_me_subscribers',
      icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'SOS Map View',
      to: '/secureme/sos-monitor-list',
      id: 'sos_monitor_list',
      icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
    },
    {
       component: CNavItem,
       name: 'TravelPath Map View',
       to: '/secureme/travelpath-monitor-list',
       id: 'travelpath_monitor_list',
       icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'SOS Lists',
      to: '/secureme/sos-users-view',
      id: 'sos_users_view',
      icon: <CIcon icon={cilWarning} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'TravelPath Lists',
      to: '/secureme/travelpath-users-view',
      id: 'travelpath_users_view',
      icon: <CIcon icon={cilRouter} customClassName="nav-icon" />,
    },
  {
    component: CNavItem,
    name: 'Reports',
    to: '/secureme/secureme-reports-cards',
    id: 'secureme_reports_cards',
    icon: <CIcon icon={cilAddressBook} customClassName="nav-icon" />,
  },

  /*{
    component: CNavItem,
    name: 'Dropdowns',
    to: '/buttons/dropdowns',
  },*/
  ];
export const OGA_NAV = {
  component: CNavGroup,
  name: 'Oga App',
  to: '/oga-app',
  id: 'oga_app',
  icon: <CIcon icon={cilPhone} customClassName="nav-icon" />,
  visible: true,
  items: []
}

export const OGA_NAV_CHILDREN = [
  {
    component: CNavItem,
    name: 'Subscriber Lists',
    to: '/oga-app/subscriber-lists',
    id: 'oga_app_subscribers',
    icon: <CIcon icon={cilUser} width={16} height={16} />,
  },
  {
    component: CNavItem,
    name: 'Workers Attendance',
    to: '/oga-app/workers-attendance',
    id: 'oga_app_workers_attendance',
    icon: <CIcon icon={cilUserFollow} width={16} height={16} />,
  },
  {
    component: CNavItem,
    name: 'IoT Device Tracking',
    to: '/oga-app/lat-iot-device',
    id: 'lat_iot_device',
    icon: <CIcon icon={cilSignalCellular0} width={16} height={16} />,
  },
  {
    component: CNavItem,
    name: 'Workers List',
    to: '/oga-app/workers-list',
    id: 'oga_app_workers_list',
    icon: <CIcon icon={cilCamera} width={16} height={16} />,
  },
  {
    component: CNavItem,
    name: 'IoT Devices',
    to: '/oga-app/iot-device-lists',
    id: 'iot_device_lists',
    icon: <CIcon icon={cilDevices} width={16} height={16} />,
  },
  {
    component: CNavItem,
    name: 'Phone lines',
    to: '/oga-app/topup-data-airtime',
    id: 'topup_data_airtime',
    icon: <CIcon icon={cilVector} width={16} height={16} />,
  },
  {
    component: CNavItem,
    name: 'Locations',
    to: '/oga-app/locations-list',
    id: 'oga_app_locations_list',
    icon: <CIcon icon={cilLocationPin} width={16} height={16} />,
  },
  {
    component: CNavItem,
    name: 'Cloud PBX/CUG',
    to: '/oga-app/cloud-pbx-cug',
    id: 'cloud_pbx_cug',
    icon: <CIcon icon={cilCloudUpload} width={16} height={16} />,
  },
  {
    component: CNavItem,
    name: 'SMS Messages',
    to: '/oga-app/oga-bulk-messages',
    id: 'oga_bulk_messages',
    icon: <CIcon icon={cilSmoke} width={16} height={16} />,
  },
  {
    component: CNavItem,
    name: 'Account',
    to: '/oga-app/oga-app-profile',
    id: 'oga_account',
    icon: <CIcon icon={cilSettings} width={16} height={16} />,
  },
  {
    component: CNavItem,
    name: 'OGA Users',
    to: '/oga-app/oga-user-lists',
    id: 'oga_user_lists',
    icon: <CIcon icon={cilPeople} width={16} height={16} />,
  },
  {
    component: CNavItem,
    name: 'Reports',
    to: '/oga-app/oga-reports-cards',
    id: 'oga_reports_cards',
    icon: <CIcon icon={cilAddressBook} width={16} height={16} />,
  },
];

export const OGA_BOIZ_NAV = {
  component: CNavGroup,
  name: 'Oga Boiz',
  to: '/oga-boiz',
  id: 'oga_boiz',
  icon: <CIcon icon={cilAirplay} customClassName="nav-icon" />,
  visible: true,
  items: []
}

export const OGA_BOIZ_NAV_CHILDREN =  [
    {
      component: CNavItem,
      name: 'Boiz subscribers',
      to: '/oga-boiz/boiz-subscriber-lists',
      id: 'boiz_subscriber_lists',
      icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
    },
    /*{
      component: CNavItem,
      name: 'Dropdowns',
      to: '/buttons/dropdowns',
    },*/
];

export const DEVICE_NAV = {
  component: CNavGroup,
  name: 'Device',
  to: '/device',
  id: 'device',
  icon: <CIcon icon={cilAirplay} customClassName="nav-icon" />,
  visible: true,
  items: []
}

export const DEVICE_NAV_CHILDREN =  [
    {
      component: CNavItem,
      name: 'Device Lists',
      to: '/device/device-lists',
      id: 'device_lists',
      icon: <CIcon icon={cilPhone} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Device Views',
      to: '/device/device-map-views',
      id: 'device_map_views',
      icon: <CIcon icon={cilMap} customClassName="nav-icon" />,
    },
    /*{
      component: CNavItem,
      name: 'Dropdowns',
      to: '/buttons/dropdowns',
    },*/
];

export const CGI_NAV = {
  component: CNavGroup,
  name: 'CGI',
  to: '/cgi',
  id: 'cgi',
  icon: <CIcon icon={cilSatelite} customClassName="nav-icon" />,
  visible: true,
  items: []
}

export const CGI_NAV_CHILDREN =  [
    {
      component: CNavItem,
      name: 'R CGI API',
      to: '/cgi/add-cgi-lookup',
      id: 'add_cgi_lookup',
      icon: <CIcon icon={cilMobile} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'R CGI NOC',
      to: '/cgi/r-cgi-noc',
      id: 'raw_cgi_noc',
      icon: <CIcon icon={cilTablet} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'R CGI Reports',
      to: '/cgi/r-cgi-reports',
      id: 'raw_cgi_reports',
      icon: <CIcon icon={cilPhone} customClassName="nav-icon" />,
    },
  {
    component: CNavItem,
    name: 'CGI NOC',
    to: '/cgi/cgi-noc',
    id: 'cgi_noc',
    icon: <CIcon icon={cilMap} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'CGI Reports',
    to: '/cgi/cgi-reports',
    id: 'cgi_reports',
    icon: <CIcon icon={cilBank} customClassName="nav-icon" />,
  },
    /*{
      component: CNavItem,
      name: 'CGI subscribers',
      to: '/cgi/cgi-subscribers',
      id: 'cgi_subscribers',
      icon: <CIcon icon={cilUserFollow} customClassName="nav-icon" />,
    },*/
    /*{
      component: CNavItem,
      name: 'Dropdowns',
      to: '/buttons/dropdowns',
    },*/
];

export const LOCATE_NOW_NAV = {
  component: CNavGroup,
  name: 'Locate Now',
  to: '/locate-now',
  id: 'locate_now',
  icon: <CIcon icon={cilLocationPin} customClassName="nav-icon" />,
  visible: true,
  items: []
}

export const LOCATE_NOW_NAV_CHILDREN =  [
    {
      component: CNavItem,
      name: 'New Look Up',
      to: '/locate-now/add-locate-now-lookup',
      id: 'add_locate_now_lookup',
      icon: <CIcon icon={cilCamera} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Look Up History',
      to: '/locate-now/locate-now-look-up-history',
      id: 'look_up_history',
      icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
    },
];

export const REPORT_NAV = {
  component: CNavGroup,
  name: 'Reports',
  to: '/reports',
  id: 'reports',
  icon: <CIcon icon={cilBank} customClassName="nav-icon" />,
  visible: true,
  items: []
}

export const REPORT_NAV_CHILDREN =  [
    {
      component: CNavItem,
      name: 'Subscribers ',
      to: '/reports/subscribers-reports',
      id: 'subscribers_reports',
      icon: <CIcon icon={cilCamera} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Track Reports',
      to: '/reports/track-reports',
      id: 'track_reports',
      icon: <CIcon icon={cilPhone} customClassName="nav-icon" />,
    },
    /* {
       component: CNavItem,
       name: 'LocateNow Look Up',
       to: '/reports/locatenow-lookup-reports',
       icon: <CIcon icon={cilMap} customClassName="nav-icon" />,
     },
     {
       component: CNavItem,
       name: 'LocateNow Proximity',
       to: '/reports/locatenow-proximity-reports',
       icon: <CIcon icon={cilLocationPin} customClassName="nav-icon" />,
     },*/
  ];

export const ADMIN_SECTION_BREAKER = {
  component: CNavTitle,
  title: true,
  name: 'Admin',
  id: 'admin_section',
};

export const ADMIN_SETTINGS_NAV = {
  component: CNavGroup,
  name: 'Admin',
  to: '/admin',
  visible: true,
  id: 'admin',
  icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
  badge: 'Admin',
  items: []
}

export const ADMIN_SETTINGS_CHILDREN = [
    {
      component: CNavItem,
      name: 'Users List',
      to: '/admin/user-lists',
      id: 'admin_user_lists',
      icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Access Roles',
      to: '/admin/access-roles-settings',
      id: 'admin_access_roles',
      icon: <CIcon icon={cilShieldAlt} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Create User',
      to: '/admin/create-user',
      id: 'admin_create_user',
      icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
      /*data: {
        title:
      }*/
    },
    {
      component: CNavItem,
      name: 'Clients',
      to: '/admin/client-lists',
      id: 'admin_clients',
      icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
      /*data: {
        title:
      }*/
    },
  ];

export const SuperNavItems = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    badge: {
      color: 'info',
      // text: 'NEW',
    },
  },
  {
    component: CNavGroup,
    name: 'Secure Me',
    to: '/secureme',
    icon: <CIcon icon={cilCursor} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Secureme Subscribers',
        to: '/secureme/secureme-subscribers-list',
        icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
      },
      /* {
         component: CNavItem,
         name: 'Secureme TravelPath',
         to: '/secureme/secureme-travelpath-history',
         icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
       },
       {
         component: CNavItem,
         name: 'Secureme SOS',
         to: '/secureme/secureme-sos-history',
         icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
       },*/
      /*{
        component: CNavItem,
        name: 'Dropdowns',
        to: '/buttons/dropdowns',
      },*/
    ],
  },
  {
    component: CNavGroup,
    name: 'Oga App',
    to: '/oga-app',
    icon: <CIcon icon={cilPhone} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Subscriber Lists',
        to: '/oga-app/subscriber-lists',
        icon: <CIcon icon={cilAlarm} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Workers list',
        to: '/oga-app/workers-list',
        icon: <CIcon icon={cilCamera} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Locations',
        to: '/oga-app/locations-list',
        icon: <CIcon icon={cilLocationPin} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Attendance',
        to: '/oga-app/workers-attendance',
        icon: <CIcon icon={cilUserFollow} customClassName="nav-icon" />,
      },
      /* {
         component: CNavItem,
         name: 'Schedule',
         to: '/oga-app/workers-schedule',
         icon: <CIcon icon={cilAlarm} customClassName="nav-icon" />,
       },*/
      /*{
        component: CNavItem,
        name: 'Dropdowns',
        to: '/buttons/dropdowns',
      },*/
    ],
  },
  {
    component: CNavGroup,
    name: 'Oga Boiz',
    to: '/oga-boiz',
    icon: <CIcon icon={cilAirplay} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Boiz subscribers',
        to: '/oga-boiz/boiz-subscriber-lists',
        icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
      },
      /*{
        component: CNavItem,
        name: 'Dropdowns',
        to: '/buttons/dropdowns',
      },*/
    ],
  },
  {
    component: CNavGroup,
    name: 'CGI',
    to: '/cgi',
    icon: <CIcon icon={cilSatelite} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'CGI API',
        to: '/cgi/add-cgi-lookup',
        icon: <CIcon icon={cilPhone} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'CGI subscribers',
        to: '/cgi/cgi-subscribers',
        icon: <CIcon icon={cilUserFollow} customClassName="nav-icon" />,
      },
      /*{
        component: CNavItem,
        name: 'Dropdowns',
        to: '/buttons/dropdowns',
      },*/
    ],
  },
  {
    component: CNavGroup,
    name: 'Locate Now',
    to: '/locate-now',
    icon: <CIcon icon={cilLocationPin} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'New Look Up',
        to: '/locate-now/add-locate-now-lookup',
        icon: <CIcon icon={cilCamera} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Look Up History',
        to: '/locate-now/locate-now-look-up-history',
        icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Reports',
    to: '/reports',
    icon: <CIcon icon={cilBank} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Subscribers ',
        to: '/reports/subscribers-reports',
        icon: <CIcon icon={cilCamera} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Track Reports',
        to: '/reports/track-reports',
        icon: <CIcon icon={cilPhone} customClassName="nav-icon" />,
      },
      /* {
         component: CNavItem,
         name: 'LocateNow Look Up',
         to: '/reports/locatenow-lookup-reports',
         icon: <CIcon icon={cilMap} customClassName="nav-icon" />,
       },
       {
         component: CNavItem,
         name: 'LocateNow Proximity',
         to: '/reports/locatenow-proximity-reports',
         icon: <CIcon icon={cilLocationPin} customClassName="nav-icon" />,
       },*/
    ],
  },
  {
    component: CNavTitle,
    name: 'ADMIN',
  },
  {
    component: CNavGroup,
    name: 'Admin',
    to: '/admin',
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
    badge: 'Admin',
    items: [
      {
        component: CNavItem,
        name: 'Users List',
        to: '/admin/user-lists',
        icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Access Roles',
        to: '/admin/access-roles-settings',
        icon: <CIcon icon={cilShieldAlt} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Create User',
        to: '/admin/create-user',
        icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
        /*data: {
          title:
        }*/
      },
      {
        component: CNavItem,
        name: 'Clients',
        to: '/admin/client-lists',
        icon: <CIcon icon={cilClipboard} customClassName="nav-icon" />,
      },
    ],
  },
]
